import { Button, Paper, Stack, SxProps, Typography } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import { combineSX } from '@/utils/combineSX';
import {
	dpOrderConfAction,
	dpOrderConfButton,
	dpOrderConfCard,
	dpOrderConfContent,
	dpOrderConfDesc,
	dpOrderConfTitle,
} from '@/components/blocks/DpOrderConfirmationCard/styles';

export const DpOrderConfirmationCard = ({
	children,
	sx,
	...props
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => (
	<Paper sx={combineSX([dpOrderConfCard, sx])} {...props}>
		{children}
	</Paper>
);

export const DpOrderConfirmationImg = (props: { src: string; alt: string }) => <Img {...props} />;

export const DpOrderConfirmationTitle = ({
	children,
	sx,
	...props
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => (
	<Typography component="h2" sx={combineSX([dpOrderConfTitle, sx])} {...props}>
		{children}
	</Typography>
);

export const DpOrderConfirmationDescription = ({
	children,
	sx,
	...props
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => (
	<Typography sx={combineSX([dpOrderConfDesc, sx])} {...props}>
		{children}
	</Typography>
);

export const DpOrderConfirmationContent = ({
	children,
	sx,
	...props
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => (
	<Stack sx={combineSX([dpOrderConfContent, sx])} {...props}>
		{children}
	</Stack>
);

export const DpOrderConfirmationAction = ({
	children,
	sx,
	...props
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => (
	<Stack alignItems="left" sx={combineSX([dpOrderConfAction, sx])} {...props}>
		{children}
	</Stack>
);

export const DpOrderConfirmationButton = ({
	children,
	sx,
	...props
}: {
	children: React.ReactNode;
	href: string;
	target: string;
	sx?: SxProps;
}) => (
	<Button type="submit" variant="contained" sx={combineSX([dpOrderConfButton, sx])} {...props}>
		{children}
	</Button>
);
